<div class="table-view-container">
  <ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

  @if (currentTable(); as table) {
    <ces-route-title [title]="table.name">
      @if (tableMenuItems().length > 0) {
        <ces-menu-button-secondary
          [hasPermission]="{ method: 'getTableDetailResource', assetId: table.assetId }"
          icon="more_vert"
          [items]="tableMenuItems()" />
      }
    </ces-route-title>
    <div class="flex flex-col gap-2 mb-(--space-4)">
      @if (periodicityLabel(); as label) {
        <div class="flex items-center gap-(--space-3)">
          <p-tag [value]="label" [rounded]="true" />
        </div>
      }
      @if (tableDescription(); as description) {
        <ces-expandable-description [description]="description" />
      }
    </div>
  }

  <p-tabs [value]="activeIndex()">
    <p-tablist>
      <p-tab [value]="0" (click)="onTabChange(0)">{{ 'tables.tabs.data' | transloco }}</p-tab>
      <p-tab [value]="1" (click)="onTabChange(1)">
        {{ 'tables.tabs.configuration' | transloco }}
        @if (isDirty()) {
          <ces-status-dot />
        }
      </p-tab>
    </p-tablist>
    @if (currentTable(); as table) {
      @if (currentAssetId(); as assetId) {
        <p-tabpanels>
          <p-tabpanel [value]="0">
            @if (visitedTabs().has(0)) {
              <ces-table-data-tab
                [hidden]="activeIndex() !== 0"
                [table]="table"
                [assetId]="assetId"
                [configDirty]="isDirty()"
                [pendingMeasures]="pendingMeasures()"
                [configVersion]="configVersion()"
                [hasSavedMeasures]="hasSavedMeasures()"
                [exportTrigger]="exportTrigger()" />
            }
          </p-tabpanel>
          <p-tabpanel [value]="1">
            @if (visitedTabs().has(1)) {
              <ces-table-config-tab
                [hidden]="activeIndex() !== 1"
                [table]="table"
                [assetId]="assetId"
                [saved]="saved()"
                (dirtyChange)="onDirtyChange($event)"
                (measuresChange)="onMeasuresChange($event)"
                (save)="onSave($event)" />
            }
          </p-tabpanel>
        </p-tabpanels>
      }
    }
  </p-tabs>
</div>
